import { defineStore } from "pinia"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { computed, ref, type Ref } from "vue"
import { RoleTypes } from "@/enums/role-types"

export const useKnownBusinessEntitiesContactsStore = defineStore(
  "knownBusinessEntitiesContactsStore",
  () => {
    const knownBusinessEntitiesContacts: Ref<KnownBusinessEntityContact[]> = ref([])

    const activeKnownBusinessEntitiesContacts = computed(() => {
      return knownBusinessEntitiesContacts.value.filter(
        (val: KnownBusinessEntityContact) => val.isActive
      )
    })

    const planners = computed(() => {
      return activeKnownBusinessEntitiesContacts.value.filter((val: KnownBusinessEntityContact) =>
        val.hasRole(RoleTypes.PLANNER)
      )
    })

    const serviceProviders = computed(() =>
      activeKnownBusinessEntitiesContacts.value.filter((val: KnownBusinessEntityContact) =>
        val.hasRole(RoleTypes.SERVICE_PROVIDER)
      )
    )

    return {
      knownBusinessEntitiesContacts,
      activeKnownBusinessEntitiesContacts,
      planners,
      serviceProviders
    }
  }
)
